import userProfilePersonalInformationTab from './user-profile-personal-information-tab.json';

export default {
  'user-profile-personal-information-tab': {
    ...userProfilePersonalInformationTab,
  },
};
